import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";

const initState = {
  dinvoicestartdate: '',
  dpaymentstartdate: '',
  sinvoicenumber: '',
  dinvoiceenddate: '',
  dpaymentenddate: ''
};

export const PaymentSearchFields = {
  name: "Payment Filter",
  initialState: initState,
  section: [
    {
      sectionId: "basicDetailSection",
      title: "Payment Filter Details Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "dinvoicestartdate",
          label: "Invoice Start Date :",
          Field_Name: "invoicestartdate",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dinvoicestartdate",
          fieldSetting: {
            placeholder: "MM/DD/YYYY",
          },
          style: { containerCss: "col-xl-4 col-lg-4 col-md-5 col-12" },
        },

        {
          id: "dpaymentstartdate",
          label: "Payment Start Date :",
          Field_Name: "Payment Start Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dpaymentstartdate",
          fieldSetting: {
            placeholder: "MM/DD/YYYY",
          },
          validation: [{ type: "require" }],
          style: { containerCss: "col-xl-4 col-lg-4 col-md-5 col-12" },
        },

        {
          id: "sinvoicenumber",
          label: "Invoice Number :",
          Field_Name: "sinvoicenumber",
          fieldType: FormFieldTypes.INPUT,
          dataField: "sinvoicenumber",
          fieldSetting: {
            placeholder: "Enter Invoice Number",
          },
          style: { containerCss: "col-xl-4 col-lg-4 col-md-5 col-12" },
        },

        {
          id: "dinvoiceenddate",
          label: "Invoice End Date :",
          Field_Name: "invoiceenddate",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dinvoiceenddate",
          fieldSetting: {
            placeholder: "MM/DD/YYYY",
            dateConfig: {
              filteredDate: null,
            },
          },
          style: { containerCss: "col-xl-4 col-lg-4 col-md-5 col-12 mt-3" },
        },

        {
          id: "dpaymentenddate",
          label: "Payment End Date :",
          Field_Name: "Payment End Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dpaymentenddate",
          fieldSetting: {
            placeholder: "MM/DD/YYYY",
            isDisable: true,
              dateConfig: {
                filteredDate:null,
            },
          },
          validation: [{ type: "require" }],
          style: { containerCss: "col-xl-4 col-lg-4 col-md-5 col-12 mt-3" },
        },

      ],
    },
  ],
};
